export default __webpack_public_path__ + "static/media/Giving-Together.c16a941e.gif";